export default "__VITE_ASSET__b0f50344__"